import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Award, Archive } from "lucide-react";
import { api } from "@/lib/api";
import { SectionHeader, Button, Loading, EmptyState, Tag } from "@/components/brand";
import { ChallengeFormDialog } from "@/components/ChallengeFormDialog";

export default function AdminChallenges() {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const list = useQuery({ queryKey: ["admin", "challenges"], queryFn: () => api("/admin/challenges") });
  const create = useMutation({ mutationFn: (body) => api("/admin/challenges", { method: "POST", body }), onSuccess: () => { setOpen(false); qc.invalidateQueries({ queryKey: ["admin", "challenges"] }); toast.success("Challenge created"); }, onError: (e) => toast.error(e.message) });
  const archive = useMutation({ mutationFn: (id) => api(`/admin/challenges/${id}/archive`, { method: "POST" }), onSuccess: () => qc.invalidateQueries({ queryKey: ["admin", "challenges"] }) });

  return (
    <div data-testid="admin-challenges-screen" className="space-y-5">
      <SectionHeader title="Challenges" subtitle="Platform-wide challenges for all members." action="New challenge" onAction={() => setOpen(true)} testID="admin-new-challenge" />
      {list.isLoading ? <Loading /> : (list.data ?? []).length === 0 ? <EmptyState icon={Award} title="No challenges yet" /> : (
        <div className="space-y-2">
          {list.data.map((c) => (
            <div key={c.id} className="flex items-center gap-3 p-4 rounded-xl2 border border-divider">
              <div className="flex-1"><div className="font-display text-lg text-ink">{c.title}{c.is_trainer_challenge ? <span className="font-body text-xs text-mutedgrey"> · {c.trainer_name}</span> : null}</div><div className="font-body text-xs text-mutedgrey">{c.participant_count} joined · {c.goal} {c.metric} · {c.reward_points} pts</div></div>
              <Tag label={c.archived ? "archived" : c.state} tone={c.archived ? "grey" : c.state === "active" ? "pink" : "dark"} />
              <button data-testid={`archive-${c.id}`} onClick={() => archive.mutate(c.id)} className="w-9 h-9 rounded-full bg-surface2 flex items-center justify-center text-mutedgrey hover:text-ink"><Archive size={16} /></button>
            </div>
          ))}
        </div>
      )}
      <ChallengeFormDialog open={open} onClose={() => setOpen(false)} onSubmit={(b) => create.mutate(b)} loading={create.isPending} allowCategory />
    </div>
  );
}
